import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA5PhONMCymMQpJPRZxt9UZRhoTK8zDYus",
  authDomain: "lcs-g-runner.firebaseapp.com",
  projectId: "lcs-g-runner",
  storageBucket: "lcs-g-runner.firebasestorage.app",
  messagingSenderId: "917604487714",
  appId: "1:917604487714:web:815fe430000c74dea7307b",
};

firebase.initializeApp(firebaseConfig);

const isSupportedFirebase = firebase.messaging.isSupported();
const messaging = isSupportedFirebase ? firebase.messaging() : null;

const publicKey =
  "BLBAxEV-HIy-L3TOVts9gIlodXwykUBSI6An-MbJnkvbcfg-8XFiNsrolP89ao9iQ1cW3dZZSli5BHLTGZHAq1s";

const FCM_SW_PATH = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js`;

const FCM_HANDLED_PREFIX = "lcs_fcm_handled:";
const FCM_HANDLED_TTL_MS = 10000;

let foregroundMessageHandler = null;
let isForegroundMessageListenerRegistered = false;
let fcmServiceWorkerRegistrationPromise = null;

export const isFcmPushSupported = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    "serviceWorker" in navigator &&
    "Notification" in window &&
    isSupportedFirebase &&
    !!messaging
  );
};

export const getWebPushDeviceVersion = () => {
  const userAgent = navigator.userAgent || "";

  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return "ios-web";
  }

  if (/Android/i.test(userAgent)) {
    return "android-web";
  }

  return "desktop-web";
};

export const registerFcmServiceWorker = async () => {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return null;
  }

  if (!fcmServiceWorkerRegistrationPromise) {
    fcmServiceWorkerRegistrationPromise = navigator.serviceWorker
      .register(FCM_SW_PATH)
      .then(async registration => {
        await navigator.serviceWorker.ready;
        return registration;
      })
      .catch(error => {
        fcmServiceWorkerRegistrationPromise = null;
        console.error("FCM service worker registration failed:", error);
        return null;
      });
  }

  return fcmServiceWorkerRegistrationPromise;
};

const getFcmDedupeKey = payload => {
  if (payload?.messageId) {
    return `mid:${payload.messageId}`;
  }

  const data = payload?.data || {};

  if (data.notification_id) {
    return `nid:${data.notification_id}`;
  }

  const notificationBlock = payload?.notification || {};

  return [
    data.notification_type || "",
    data.ticket_id || "",
    data.order_id || "",
    notificationBlock.title || data.title || "",
  ].join(":");
};

const shouldSkipDuplicateTabMessage = payload => {
  if (typeof window === "undefined") {
    return false;
  }

  const dedupeKey = getFcmDedupeKey(payload);

  if (!dedupeKey) {
    return false;
  }

  const storageKey = `${FCM_HANDLED_PREFIX}${dedupeKey}`;
  const handledAt = Number(localStorage.getItem(storageKey) || 0);
  const now = Date.now();

  if (handledAt && now - handledAt < FCM_HANDLED_TTL_MS) {
    return true;
  }

  localStorage.setItem(storageKey, String(now));
  return false;
};

export const getToken = async () => {
  if (!messaging) {
    return null;
  }

  try {
    const serviceWorkerRegistration = await registerFcmServiceWorker();

    if (!serviceWorkerRegistration) {
      return null;
    }

    return await messaging.getToken({
      vapidKey: publicKey,
      serviceWorkerRegistration,
    });
  } catch (error) {
    console.error("FCM getToken failed:", error);
    return null;
  }
};

export const requestPermission = async callback => {
  if (!isFcmPushSupported()) {
    return;
  }

  const permission = await Notification.requestPermission();

  if (permission === "granted" && typeof callback === "function") {
    await callback();
  }
};

export const onMessageListener = callback => {
  if (!messaging || typeof callback !== "function") {
    return;
  }

  foregroundMessageHandler = callback;

  if (isForegroundMessageListenerRegistered) {
    return;
  }

  messaging.onMessage(payload => {
    if (shouldSkipDuplicateTabMessage(payload)) {
      return;
    }

    foregroundMessageHandler?.(payload);
  });

  isForegroundMessageListenerRegistered = true;
};

export { FCM_HANDLED_PREFIX };
